import React from 'react';
import { Dropdown as WixDropdown, DropdownProps } from '@wix/design-system';

// read more about Dropdown's config:
// https://wix.github.io/wix-style-react
const Dropdown = (config: DropdownProps) => <WixDropdown {...config} />;

export default Dropdown;
